import React, { useState } from 'react';
import { useForm } from 'react-hook-form'
import { Flex, Heading, FormErrorMessage,  FormLabel,  FormControl,  Input,  Button, Box, Stack, SimpleGrid, Select } from '@chakra-ui/react';
import { FIELD_TYPES } from '../../../../../constants';

type Props = {
  item: any;
  index: number;
  onFieldUpdate: (item:any, index:number) => void;
};

function FieldItem({ item, index, onFieldUpdate }: Props) {
  const [isEdit, setIsEdit] = useState(false);

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: item
  });

  function onSubmit(values:any) {
    onFieldUpdate(values, index);
    setIsEdit(false);
  }

  return (
    <>
    {isEdit ? (
      <Box border="1px" borderColor="b.lg" p="4">
        <form name="newFieldGroup" onSubmit={handleSubmit(onSubmit)}>
          <SimpleGrid columns={[3]} spacing='10px' >
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='type'>필드 타입</FormLabel>
              <Select size="sm" placeholder='필드 타입' {...register('type', { required: true })}>
                {
                  FIELD_TYPES.map((item:any, index:number) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))
                }
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='key'>필드 key</FormLabel>
              <Input
                size="sm" 
                id='key'
                placeholder='필드 key(영문자, 숫자, _ 만 가능)'
                {...register('key', { required: true })}
              />
            </FormControl>
            <Box></Box>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='label'>라벨명</FormLabel>
              <Input
                size="sm"
                id='label'
                placeholder='라벨명'
                {...register('label', { required: true })}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='placeholder'>도움말</FormLabel>
              <Input
                size="sm"
                id='placeholder'
                placeholder='도움말'
                {...register('placeholder', { required: false })}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='defaultValue'>기본값</FormLabel>
              <Input
                size="sm"
                id='defaultValue'
                placeholder='기본값'
                {...register('defaultValue', { required: false })}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='options'>옵션(radio, checkbox, select)</FormLabel>
              <Input
                size="sm"
                id='options'
                placeholder='콤마(,)로 구분'
                {...register('options', { required: false })}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='showLabel'>라벨 표시</FormLabel>
              <Select size="sm" placeholder='라벨 표시' {...register('showLabel', { required: true })}>
                <option value="true">표시</option>
                <option value="false">표시 안 함</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='required'>필수 여부</FormLabel>
              <Select size="sm" placeholder='필수 여부' {...register('required', { required: true })}>
                <option value="true">필수</option>
                <option value="false">선택</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" htmlFor='style.width'>너비</FormLabel>
              <Input
                size="sm"
                id='style.width'
                placeholder='너비'
                {...register('style.width', { required: false })}
              />
            </FormControl>
            {/* <FormControl>
              <FormLabel htmlFor='validation'>필드 validation</FormLabel>
              <Input
                id='validation'
                placeholder='필드 validation'
                {...register('validation', { required: true })}
              />
            </FormControl> */}
          </SimpleGrid>
          <Box textAlign="right">
            <Button variant='outline' size="xs" mt="4" colorScheme="g" isLoading={isSubmitting} type='submit'>
              적용
            </Button>
          </Box>
        </form>
      </Box>
    ) : (
      <Box border="1px" borderColor="b.lg" p="4">
      <Flex justify="space-between" align="center">
        <Heading as="h3" size="sm">
          {
            item.label === '' ? '라벨을 입력해 주세요.' : `${item.label} (${item.key})`
          }
        </Heading>
        <Button variant='outline' size="xs" colorScheme="g" type='button' onClick={() => setIsEdit(true)}>
          수정
        </Button>
      </Flex>
      </Box>
    )}
    </>
  );
}

FieldItem.defaultProps = {
};

export default FieldItem;